<script setup lang="ts">
import { useRouter } from 'vue-router';

const router = useRouter();

interface Props {
  routeName: string;
  routeParams?: Record<string, any>;
  routeQuery?: Record<string, any>;
}

const props = defineProps<Props>();

const handleClick = () => {
  router.push({
    name: props.routeName,
    params: props.routeParams,
    query: props.routeQuery,
  });
};
</script>

<template>
  <div 
    class="flex justify-between items-center bg-[#fdf4ff] p-4 rounded-lg cursor-pointer"
    @click="handleClick"
  >
    <div class="flex flex-col">
      <slot></slot>
    </div>
    <div class="">
      <i class="fas fa-chevron-right text-sm"></i>
    </div>
  </div>
</template>